window.productFlickity = null;
let $currentZoomItem = null;

$(document).ready(function () {
  if ($(window).width() > 768) {
    enableZoomDesktop();
  } else {
    enableZoomMobile();
  }
});

function enableZoomDesktop() {
  $(".template__full-width-pdp .product__grid .product-image-wrapper").each(function () {
    const $item = $(this);
    const $zoomed = $item.find(".zoomed-image");
    const zoomUrl = $item.find(".zoomable").data("zoom");

    if (!zoomUrl) return;

    // Use 'first-slide' class to determine initial zoom
    const initialZoom = $item.parents('.product__media').hasClass("first-slide") ? "150%" : "200%";
    console.log("first-slide",$item.parents('.product__media').hasClass("first-slide"))

    let isZoomed = false;
    let isDragging = false;
    let dragStarted = false;
    let isAnimating = false; // Prevent fast click glitches

    let startX = 0, startY = 0;
    let bgX = 50, bgY = 50;
    let startBgX = 50, startBgY = 50;

    function setBg(x, y) {
      bgX = Math.max(0, Math.min(100, x));
      bgY = Math.max(0, Math.min(100, y));
      $zoomed.css("background-position", `${bgX}% ${bgY}%`);
    }

    function getPercent(e) {
      const rect = $item[0].getBoundingClientRect();
      return {
        x: ((e.clientX - rect.left) / rect.width) * 100,
        y: ((e.clientY - rect.top) / rect.height) * 100
      };
    }

    // Desktop - Initial setup - START AT 100%
    $zoomed.css({
      backgroundImage: `url(${zoomUrl})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "100%",
      backgroundPosition: "50% 50%",
      transition: "none"
    });

    // On click: toggle zoom
    $item.on("click", function (e) {
      if (dragStarted) {
        dragStarted = false;
        return;
      }

      // Prevent fast click glitches
      if (isAnimating) return;

      if ($currentZoomItem && $currentZoomItem[0] !== $item[0]) {
        const $prevZoomed = $currentZoomItem.find(".zoomed-image");
        $prevZoomed.stop(true, false).css({
          transition: "none",
          opacity: 0,
          backgroundSize: "100%"
        }).hide();
        $currentZoomItem.closest(".product__media").removeClass("zoom-active");
      }

      if (!isZoomed) {
        isAnimating = true;
        const p = getPercent(e);
        setBg(p.x, p.y);

        $zoomed.show();
        
        // Force reflow
        $zoomed[0].offsetHeight;
        
        $zoomed.css({
          transition: "background-size 0.5s ease-out",
          opacity: 1,
          backgroundSize: initialZoom
        });

        isZoomed = true;
        $item.css("cursor", "grab");
        $item.closest(".product__media").addClass("zoom-active");
        $currentZoomItem = $item;

        if (window.productFlickity) {
          window.productFlickity.options.draggable = false;
          window.productFlickity.updateDraggable();
        }

        setTimeout(() => { isAnimating = false; }, 500);
      } else {
        isAnimating = true;

        // IMPORTANT: opacity change nathi karto
        $zoomed.css({
          transition: "background-size 0.5s ease-out",
          backgroundSize: "100%"
        });

        setTimeout(() => {
          $zoomed.css({
            transition: "none",
            opacity: 0   // ek j vaar end ma
          });
          $zoomed.hide();
          isAnimating = false;
        }, 500);

        isZoomed = false;
        $item.css("cursor", "default");
        $item.closest(".product__media").removeClass("zoom-active");

        if (window.productFlickity) {
          window.productFlickity.options.draggable = true;
          window.productFlickity.updateDraggable();
        }
      }
    });


    $item.on("mousedown", function (e) {
      if (!isZoomed) return;

      isDragging = true;
      dragStarted = false;

      startX = e.clientX;
      startY = e.clientY;
      startBgX = bgX;
      startBgY = bgY;

      $item.css("cursor", "grabbing");
      e.preventDefault();
    });

    $(document).on("mousemove", function (e) {
      if (!isDragging || !isZoomed) return;

      const rect = $item[0].getBoundingClientRect();
      const diffX = e.clientX - startX;
      const diffY = e.clientY - startY;

      if (Math.abs(diffX) > 2 || Math.abs(diffY) > 2) {
        dragStarted = true;
      }

      setBg(
        startBgX - (diffX / rect.width) * 100,
        startBgY - (diffY / rect.height) * 100
      );
    });

    $(document).on("mouseup", function () {
      isDragging = false;
      $item.css("cursor", "grab");
    });
  });
}

function enableZoomMobile() {
  const TAP_THRESHOLD = 8;

  $(".template__full-width-pdp .product__grid .product-image-wrapper").each(function () {
    const $item = $(this);
    const $zoomed = $item.find(".zoomed-image");
    const zoomUrl = $item.find(".zoomable").data("zoom");

    if (!zoomUrl) return;

    const targetZoom = "200%";

    $zoomed.css({
      backgroundImage: `url(${zoomUrl})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "100%",
      backgroundPosition: "50% 50%",
      transition: "none"
    });

    let isZoomed = false;
    let isAnimating = false; // Prevent fast tap glitches
    let startX = 0, startY = 0;
    let moved = false;

    let bgX = 50, bgY = 50;
    let startBgX = 50, startBgY = 50;

    function getPoint(e) {
      const t = e.originalEvent.touches[0];
      return { x: t.clientX, y: t.clientY };
    }

    function setBg(x, y) {
      bgX = Math.max(0, Math.min(100, x));
      bgY = Math.max(0, Math.min(100, y));
      $zoomed.css("background-position", `${bgX}% ${bgY}%`);
    }

    $item.on("touchstart", function (e) {
      const p = getPoint(e);
      startX = p.x;
      startY = p.y;
      moved = false;

      startBgX = bgX;
      startBgY = bgY;
    });

    $item.on("touchmove", function (e) {
      const p = getPoint(e);
      const dx = p.x - startX;
      const dy = p.y - startY;

      if (Math.abs(dx) > TAP_THRESHOLD || Math.abs(dy) > TAP_THRESHOLD) {
        moved = true;
      }

      if (isZoomed) {
        const rect = $item[0].getBoundingClientRect();
        setBg(
          startBgX - (dx / rect.width) * 100,
          startBgY - (dy / rect.height) * 100
        );
        e.preventDefault();
      }
    });

    $item.on("touchend touchcancel", function () {
      if (moved || isAnimating) return;

      if (!isZoomed) {
        isAnimating = true;
        
        $(".zoomed-image").stop(true, false).css({
          transition: "none",
          opacity: 0,
          backgroundSize: "100%"
        }).hide();
        $(".product__media").removeClass("zoom-active");

        $zoomed.show();
        
        // Force reflow
        $zoomed[0].offsetHeight;
        
        $zoomed.css({
          transition: "background-size 0.5s ease-out",
          opacity: 1,
          backgroundSize: targetZoom
        });
        
        $item.closest(".product__media").addClass("zoom-active");
        isZoomed = true;

        if (window.productFlickity) {
          window.productFlickity.options.draggable = false;
          window.productFlickity.updateDraggable();
        }

        setTimeout(() => { isAnimating = false; }, 500);
      } else {
        isAnimating = true;

        $zoomed.css({
          transition: "background-size 0.5s ease-out",
          backgroundSize: "100%"
        });

        setTimeout(() => {
          $zoomed.css({
            transition: "none",
            opacity: 0
          });
          $zoomed.hide();
          isAnimating = false;
        }, 500);

        $item.closest(".product__media").removeClass("zoom-active");
        isZoomed = false;

        if (window.productFlickity) {
          window.productFlickity.options.draggable = true;
          window.productFlickity.updateDraggable();
        }
      }


    });

  });
}